<script lang="ts">
	import { box, mergeProps } from "svelte-toolbelt";
	import type { MenuGroupProps } from "../types.js";
	import { useMenuGroup } from "../menu.svelte.js";
	import { useId } from "../../../internal/use-id.js";

	let {
		children,
		child,
		ref = $bindable(null),
		id = useId(),
		...restProps
	}: MenuGroupProps = $props();

	const groupState = useMenuGroup({
		id: box.with(() => id),
		ref: box.with(
			() => ref,
			(v) => (ref = v)
		),
	});
	const mergedProps = $derived(mergeProps(restProps, groupState.props));
</script>

{#if child}
	{@render child({ props: mergedProps })}
{:else}
	<div {...mergedProps}>
		{@render children?.()}
	</div>
{/if}
